import { useState } from "react";
import { useAlerts } from "@/hooks";
import { getErrorMessage } from "@/utils/getErrorMessage";
import { useStopAlertMutation } from "../services/alertManagerApi";

export const useStopAlertModal = () => {
  const { showSuccess, showError } = useAlerts();
  const [open, setOpen] = useState(false);
  const [alertToStop, setAlertToStop] = useState<string | null>(null);
  const [stopAlert] = useStopAlertMutation();

  const openModal = (alertName: string) => {
    setAlertToStop(alertName);
    setOpen(true);
  };

  const closeModal = () => {
    setOpen(false);
    setAlertToStop(null);
  };

  const handleStop = async () => {
    if (!alertToStop) return;
    try {
      await stopAlert({ alert_name: alertToStop }).unwrap();
      showSuccess(`Alert "${alertToStop}" stopped`);
      closeModal();
    } catch (err) {
      showError(`Failed to stop alert: ${getErrorMessage(err)}`);
    }
  };

  return { open, alertToStop, openModal, closeModal, handleStop };
};
